<div class="container">
  <div *ngIf="!productPacks" class="row empty">
    <div class="col-md-12">
      Keine Produkte verfügbar
    </div>
  </div>
  <section class="row">
    <app-product-pack *ngFor="let productPack of productPacks" [productPack]="productPack" [singleProductView]="true"
      (counterChanged)="onCounterChanged($event)" [ngClass]="{'col-xl-12 col-xga-6': true}"></app-product-pack>
  </section>
</div>
